import React from 'react';
import '../WellDiagnosis.scss';

interface TestCommentWidgetProps {
  runlife: string;
}

const TestCommentWidget: React.FC<TestCommentWidgetProps> = ({ runlife }) => {
  return (
    <div className='diagnosis-main-container diagnosis-table-widget'>
      <header className='cust-table-header'>
        <div className='cust-table-header-wrap diagnosis-table-header-wrap'>
          <h1 className='table-header-title'>Comment for this Test {runlife ? `- ${runlife}` : ''}</h1>
        </div>
      </header>
      <div className='diagnosis-test-comment-content'>
        <textarea className='comment-preview-textarea' placeholder='Test comment...'></textarea>
      </div>
    </div>
  );
};

export default TestCommentWidget;
